import React from 'react';
import { FormForm } from '../../../../../components/Form/FormForm';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { Stack } from '../../../../../components/Stack/Stack';
import { Grid } from '../../../../../components/Grid/Grid';
import { Label } from '../../../../../components/Form/Label/Label';
import { FormCheckbox } from '../../../../../components/Form/Checkbox/FormCheckbox';
import { useAsyncValue } from '../../../../../model/data';
import { Event } from '../../../../../model/event';
import { getPricingPartNames } from '../../../../../model/price';
import { t } from '../../../../../locales/translate';
import { Spacer } from '../../../../../components/Spacer/Spacer';

interface Props {
  event: Event;
  onClose: () => void;
}

interface Model {
  basePrice?: boolean;
  fees?: boolean;
  paidLocalTickets?: boolean;
  freeLocalTickets?: boolean;
}

export function SalesReport({ onClose, event }: Props): JSX.Element {
  const { model, onSubmit, fields, submissionStatus, updateFields } = useForm<Model>({
    model: {
      basePrice: true,
      fees: true,
      paidLocalTickets: true,
      freeLocalTickets: true,
    },
    onSubmit: () => {
      const params = new URLSearchParams(model as unknown as Record<string, string>).toString();
      window.open(event.salesReportPdfDownloadUrl + '?' + params, '_blank');
      onClose();
    },
  });
  const [priceParts, loading] = useAsyncValue(async () => {
    const parts = await getPricingPartNames({ event });
    const data = {};
    parts.forEach((e) => (data[e] = true));
    updateFields(data);
    return parts;
  }, [event.id]);
  return (
    <FormForm
      onClose={onClose}
      onSubmit={onSubmit}
      saveButtonTitle={t.page.salesReport.generatePdf}
      canSubmit={!loading}
      loading={submissionStatus === 'submitting'}
    >
      <Stack>
        <p>{t.page.salesReport.explanation}</p>
        <Grid noStretch>
          <Stack>
            <Label title={t.page.salesReport.priceParts} />
            <FormCheckbox label={t.page.salesReport.basePrice} {...fields.basePrice} />
            <FormCheckbox label={t.page.salesReport.fee} {...fields.fees} />
            {(priceParts ?? []).map((e) => (
              <>
                <FormCheckbox key={e} label={e} {...fields[e]} />
              </>
            ))}
          </Stack>
          <Stack>
            <Label title={t.page.salesReport.prices} />
            <FormCheckbox label={t.page.salesReport.inclPaidLocalTickets} {...fields.paidLocalTickets} />
            <FormCheckbox label={t.page.salesReport.inclFreeLocalTickets} {...fields.freeLocalTickets} />
          </Stack>
        </Grid>
      </Stack>
      <Spacer />
    </FormForm>
  );
}
